"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoredSerializedValue = void 0;
class StoredSerializedValue {
    constructor(storage, key, serializer) {
        this.storage = storage;
        this.key = key;
        this.serializer = serializer;
        this.serializer = serializer;
    }
    get value() {
        if (this.cachedValue == undefined) {
            const s = this.storage.getItem(this.key);
            this.cachedValue = s == null ? null : this.serializer.deserialize(s);
        }
        return this.cachedValue;
    }
    set value(value) {
        if (value == null)
            this.storage.removeItem(this.key);
        else
            this.storage.setItem(this.key, this.serializer.serialize(value));
        this.cachedValue = undefined;
    }
    clear() { this.value = null; }
    refresh() {
        this.cachedValue = undefined;
        return this.value;
    }
}
exports.StoredSerializedValue = StoredSerializedValue;
//# sourceMappingURL=StoredSerializedValue.js.map